module.exports = __webpack_public_path__ + "static/img/himg1.9328ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/himg1.png
// module id = wgvQ
// module chunks = 0